export const CONTENT_PAGE_EVENT_NAMES = {
  CLICKED_PROGRESS_MONITORING_LINK: 'Clicked Progress Monitoring Link'
}
